export class AppConfig{

    public API_ENDPOINT = 'http://prod-swiftcds-load-balancer-1550470173.us-east-2.elb.amazonaws.com/api/swiftcds/';
    public USER_ENDPOINT = 'http://prod-swiftcds-load-balancer-1550470173.us-east-2.elb.amazonaws.com/api/'

}
